import React from 'react';
import { Link } from 'react-router-dom';

const MeetSurgeon = () => {
    return (
        <section className="section" style={{ backgroundColor: 'var(--white)' }}>
            <div className="container">
                {/* Centered Section Title */}
                <h2 style={{
                    fontSize: 'clamp(2.5rem, 5vw, 3.2rem)',
                    marginBottom: '60px',
                    fontFamily: 'var(--font-heading)',
                    color: 'var(--secondary)',
                    lineHeight: '1.2',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    textAlign: 'center'
                }}>
                    ABOUT THE FOUNDER
                </h2>


                {/* Top Section: Image + Professional Overview & Clinical Expertise */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '60px', flexWrap: 'wrap', marginBottom: '60px' }}>
                    {/* Left: Image */}
                    <div style={{ flex: 1, minWidth: '300px', position: 'relative' }}>
                        <div style={{
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#D1A3A2',
                            borderRadius: '12px',
                            zIndex: 0
                        }}></div>
                        <img
                            src="/monica1.png"
                            alt="Nyssa Healthcare"
                            style={{
                                width: '100%',
                                position: 'relative',
                                zIndex: 1,
                                boxShadow: 'var(--shadow-lg)',
                                borderRadius: '12px'
                            }}
                        />
                    </div>

                    {/* Right: Professional Overview & Clinical Expertise */}
                    <div style={{ flex: 1.2, minWidth: '300px' }}>
                        <h3 style={{
                            fontSize: 'clamp(1.8rem, 4vw, 2.2rem)',
                            marginBottom: '20px',
                            fontFamily: 'var(--font-heading)',
                            color: 'var(--secondary)',
                            lineHeight: '1.3',
                            fontWeight: '600'
                        }}>
                            Dr. Monika Meti-Kullolli
                        </h3>

                        {/* Professional Overview */}
                        <h4 style={{
                            fontSize: '1.4rem',
                            marginTop: '30px',
                            marginBottom: '15px',
                            fontFamily: 'var(--font-heading)',
                            color: 'var(--secondary)',
                            fontWeight: '600'
                        }}>
                            Professional Overview
                        </h4>
                        <p style={{ marginBottom: '25px', color: 'var(--text-light)', fontSize: '1.05rem', lineHeight: '1.8' }}>
                            A Consultant Gynaecologist and healthcare leader with extensive experience in clinical practice, medical administration, and women's health services. Currently serving as the Medical Superintendent and Head of the Department of Obstetrics & Gynaecology at Kullolli Institute of Health Services, Sangli. Known for a compassionate and ethical approach to care, with a strong focus on patient safety, clinical excellence, and quality healthcare delivery.
                        </p>

                        {/* Clinical Expertise */}
                        <h4 style={{
                            fontSize: '1.3rem',
                            marginTop: '30px',
                            marginBottom: '15px',
                            fontFamily: 'var(--font-heading)',
                            color: 'var(--secondary)',
                            fontWeight: '600'
                        }}>
                            Clinical Expertise:
                        </h4>
                        <ul style={{
                            listStyle: 'none',
                            padding: 0,
                            marginBottom: '25px',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: '10px'
                        }}>
                            {[
                                'High-risk obstetrics & gynaecology',
                                'Laparoscopic and minimally invasive surgeries',
                                'Cosmetic gynaecology',
                                'Cervical cancer screening & colposcopy',
                                'Pelvic floor and incontinence management',
                                'Preventive women\'s healthcare',
                                'Ultrasound and diagnostic procedures'
                            ].map((item, idx) => (
                                <li key={idx} style={{
                                    paddingLeft: '25px',
                                    position: 'relative',
                                    color: 'var(--text-light)',
                                    fontSize: '1.05rem',
                                    lineHeight: '1.6'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: '0',
                                        color: 'var(--primary)',
                                        fontSize: '1.2rem'
                                    }}>•</span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bottom Section: Full Width Content */}
                <div style={{ marginTop: '40px' }}>
                    {/* Three Column Layout for Academic, International, and Leadership - Card Style */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                        gap: '30px',
                        marginBottom: '40px'
                    }}>
                        {/* Academic & Research Contributions Card */}
                        <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            padding: '30px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            cursor: 'default',
                            border: '1px solid rgba(181,131,131,0.1)'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                            }}
                        >
                            <h4 style={{
                                fontSize: '1.4rem',
                                marginBottom: '20px',
                                fontFamily: 'var(--font-heading)',
                                color: 'var(--secondary)',
                                fontWeight: '600',
                                borderBottom: '2px solid var(--primary)',
                                paddingBottom: '10px'
                            }}>
                                Academic & Research Contributions
                            </h4>
                            <ul style={{
                                listStyle: 'none',
                                padding: 0,
                                marginBottom: '0'
                            }}>
                                {[
                                    'Presented research on "Comparison of VIA and Pap Smear as Screening Tools for Cervical Cancer" at ICCP National Conference and RCOG World Congress (2014)',
                                    'Presented and awarded Best Paper for "Seven Effective and Safe Steps of Abdominal Hysterectomy – Kullolli Method" at MOGs & SAFOG Conference',
                                    'Published research on Role of COVID Vaccination in Disease Outcome',
                                    'Speaker at national and international medical conferences',
                                    'Contributor to CME programs and clinical workshops'
                                ].map((item, idx) => (
                                    <li key={idx} style={{
                                        marginBottom: '12px',
                                        paddingLeft: '25px',
                                        position: 'relative',
                                        color: 'var(--text-light)',
                                        fontSize: '1.05rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            left: '0',
                                            color: 'var(--primary)',
                                            fontSize: '1.2rem'
                                        }}>•</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* International & Social Medical Work Card */}
                        <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            padding: '30px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            cursor: 'default',
                            border: '1px solid rgba(181,131,131,0.1)'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                            }}
                        >
                            <h4 style={{
                                fontSize: '1.4rem',
                                marginBottom: '20px',
                                fontFamily: 'var(--font-heading)',
                                color: 'var(--secondary)',
                                fontWeight: '600',
                                borderBottom: '2px solid var(--primary)',
                                paddingBottom: '10px'
                            }}>
                                International & Social Medical Work
                            </h4>
                            <ul style={{
                                listStyle: 'none',
                                padding: 0,
                                marginBottom: '0'
                            }}>
                                {[
                                    'Surgical Faculty – Medical Mission to Zimbabwe (2015)',
                                    'Surgical Faculty – Medical Mission to Nigeria (2018)',
                                    'Performed over 100 free major surgeries as part of humanitarian missions',
                                    'Visiting Surgeon at SEARCH Hospital, Gadchiroli (Dr. Rani & Dr. Abhay Bang\'s Institute)'
                                ].map((item, idx) => (
                                    <li key={idx} style={{
                                        marginBottom: '12px',
                                        paddingLeft: '25px',
                                        position: 'relative',
                                        color: 'var(--text-light)',
                                        fontSize: '1.05rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            left: '0',
                                            color: 'var(--primary)',
                                            fontSize: '1.2rem'
                                        }}>•</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Leadership & Professional Roles Card */}
                        <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            padding: '30px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            cursor: 'default',
                            border: '1px solid rgba(181,131,131,0.1)'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                            }}
                        >
                            <h4 style={{
                                fontSize: '1.4rem',
                                marginBottom: '20px',
                                fontFamily: 'var(--font-heading)',
                                color: 'var(--secondary)',
                                fontWeight: '600',
                                borderBottom: '2px solid var(--primary)',
                                paddingBottom: '10px'
                            }}>
                                Leadership & Professional Roles
                            </h4>
                            <p style={{ fontSize: '1.1rem', fontWeight: '600', color: 'var(--secondary)', marginBottom: '15px' }}>Present Roles:</p>
                            <ul style={{
                                listStyle: 'none',
                                padding: 0,
                                marginBottom: '0'
                            }}>
                                {[
                                    'Medical Superintendent – Kullolli Institute of Health Services',
                                    'Head, Department of Obstetrics & Gynaecology',
                                    'Vice President – Sangli District Athletic Association (2023–27)',
                                    'Secretary – GODH Foundation'
                                ].map((item, idx) => (
                                    <li key={idx} style={{
                                        marginBottom: '10px',
                                        paddingLeft: '25px',
                                        position: 'relative',
                                        color: 'var(--text-light)',
                                        fontSize: '1.05rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            left: '0',
                                            color: 'var(--primary)',
                                            fontSize: '1.2rem'
                                        }}>•</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Teaching & Training and Awards in Two Columns */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
                        gap: '40px',
                        marginTop: '40px',
                        marginBottom: '40px'
                    }}>
                        {/* Teaching & Training */}
                        <div>
                            <h4 style={{
                                fontSize: '1.3rem',
                                marginBottom: '15px',
                                fontFamily: 'var(--font-heading)',
                                color: 'var(--secondary)',
                                fontWeight: '600'
                            }}>
                                Teaching & Training
                            </h4>
                            <ul style={{
                                listStyle: 'none',
                                padding: 0,
                                marginBottom: '0'
                            }}>
                                {[
                                    'Faculty for laparoscopic hands-on workshops',
                                    'Trainer for cervical cancer screening programs',
                                    'Compiler of Cervical Cancer Screening Training Manual (Rotary District 3170)',
                                    'Regular speaker at CMEs and professional forums'
                                ].map((item, idx) => (
                                    <li key={idx} style={{
                                        marginBottom: '10px',
                                        paddingLeft: '25px',
                                        position: 'relative',
                                        color: 'var(--text-light)',
                                        fontSize: '1.05rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            left: '0',
                                            color: 'var(--primary)',
                                            fontSize: '1.2rem'
                                        }}>•</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Awards & Recognitions */}
                        <div>
                            <h4 style={{
                                fontSize: '1.3rem',
                                marginBottom: '15px',
                                fontFamily: 'var(--font-heading)',
                                color: 'var(--secondary)',
                                fontWeight: '600'
                            }}>
                                Awards & Recognitions
                            </h4>
                            <ul style={{
                                listStyle: 'none',
                                padding: 0,
                                marginBottom: '0'
                            }}>
                                {[
                                    'COVID WARRIOR Award – Shiv Pratishthan',
                                    'DEV DHOOT Award – Presented by Hon. CM Devendra Fadnavis',
                                    'Recognition by IMA Sangli for exemplary medical service',
                                    'Rotary International – Four Avenue Service Award',
                                    'Rotary Foundation – Major Donor Recognition',
                                    'Presidential Citation for outstanding leadership',
                                    'Best President & Best Assistant Governor Awards',
                                    'RI Presidential Award for Membership Development'
                                ].map((item, idx) => (
                                    <li key={idx} style={{
                                        marginBottom: '10px',
                                        paddingLeft: '25px',
                                        position: 'relative',
                                        color: 'var(--text-light)',
                                        fontSize: '1.05rem',
                                        lineHeight: '1.6'
                                    }}>
                                        <span style={{
                                            position: 'absolute',
                                            left: '0',
                                            color: 'var(--primary)',
                                            fontSize: '1.2rem'
                                        }}>•</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Philosophy of Care */}
                    <div style={{
                        marginTop: '40px',
                        padding: '30px',
                        background: 'linear-gradient(135deg, rgba(181,131,131,0.08) 0%, rgba(181,131,131,0.04) 100%)',
                        borderRadius: '12px',
                        borderLeft: '4px solid var(--primary)'
                    }}>
                        <h4 style={{
                            fontSize: '1.3rem',
                            marginBottom: '15px',
                            fontFamily: 'var(--font-heading)',
                            color: 'var(--secondary)',
                            fontWeight: '600'
                        }}>
                            Philosophy of Care
                        </h4>

                        <p style={{ marginBottom: '0', color: 'var(--secondary)', fontSize: '1.1rem', lineHeight: '1.8', fontWeight: '500', fontStyle: 'italic' }}>
                            Nyssa reflects her vision of holistic healthcare where Science, Spirituality, Empathy, Sensitivity, & Trust come together to support women through every stage of life.
                        </p>
                    </div>

                    {/* Social Media */}
                    {/* <div style={{ marginTop: '40px' }}>
                        <h4 style={{
                            fontSize: '1.2rem',
                            marginBottom: '15px',
                            fontFamily: 'var(--font-heading)',
                            color: 'var(--secondary)',
                            fontWeight: '600'
                        }}>
                            Presence on Social Platforms:
                        </h4>
                        <div style={{ display: 'flex', gap: '15px', marginBottom: '30px' }}>
                            <a href="https://www.facebook.com/profile.php?id=61584980792095" target="_blank" rel="noopener noreferrer" style={{
                                width: '45px',
                                height: '45px',
                                borderRadius: '50%',
                                background: '#1877F2',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#fff',
                                fontSize: '1.3rem',
                                transition: 'transform 0.3s ease',
                                textDecoration: 'none'
                            }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            >
                                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
                            </a>
                            <a href="https://www.instagram.com/nyssa_health/" target="_blank" rel="noopener noreferrer" style={{
                                width: '45px',
                                height: '45px',
                                borderRadius: '50%',
                                background: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#fff',
                                fontSize: '1.3rem',
                                transition: 'transform 0.3s ease',
                                textDecoration: 'none'
                            }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            >
                                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
                            </a>
                            
                        </div>
                    </div>

                    <Link to="/about" className="btn btn-outline">
                        Learn More About Nyssa
                    </Link> */}
                </div>
            </div>

            {/* Mobile Responsive Styles */}
            <style>{`
                @media (max-width: 768px) {
                    .container {
                        padding: 0 20px !important;
                    }

                    section h2 {
                        font-size: 2rem !important;
                        margin-bottom: 40px !important;
                    }

                    section h3 {
                        font-size: 1.8rem !important;
                    }

                    section h4 {
                        font-size: 1.2rem !important;
                    }

                    section p, section li {
                        font-size: 1rem !important;
                    }

                    /* Single column on mobile */
                    section > div > div[style*="display: flex"],
                    section > div > div[style*="display: grid"] {
                        flex-direction: column !important;
                        grid-template-columns: 1fr !important;
                    }

                    /* Reduce gaps on mobile */
                    section > div > div[style*="gap"] {
                        gap: 30px !important;
                    }

                    /* Card padding on mobile */
                    section > div > div > div[style*="padding: 30px"] {
                        padding: 20px !important;
                    }

                    /* Social icons */
                    section a[style*="width: 45px"] {
                        width: 40px !important;
                        height: 40px !important;
                    }
                }
            `}</style>
        </section>
    );
};

export default MeetSurgeon;
